import React, {useState, useEffect} from 'react';
import './DetailsClub.css';
import ClubCalendrier from '../components/ClubCalendrier';
import { useLocation } from 'react-router-dom';
import { domain, getLongNameChamp } from '../variables';
import axios from 'axios';
import LogoClub from '../components/LogoClub';
import JoueurInfo from '../components/JoueurInfo';

function DetailsClub({championnat, club}) {
    const state = useLocation();
    const [players, setPlayers] = useState([]);
    const [palmares, setPalmares] = useState([]);
    const [contacts, setContacts] = useState([]);

    let onglet = 1; 
    if (state !== undefined && state !== null) {
        if (state.state !== undefined && state.state !== null) {
            onglet = state.state.onglet;
        }
    }

    const [currentOnglet, setCurrentOnglet] = useState(onglet);

    useEffect(() => {
        switch (currentOnglet) {
            case 1:
                if (players.length < 1) {
                    // on récupère les joueurs
                    getPlayers();
                }
                break;
            case 3:
                if (palmares.length < 1) {
                    // on récupère les palmares
                    getPalmares();
                }
                break;
            case 4:
                if (contacts.length < 1) {
                    // on récupère les contacts
                    getContact();
                }
                break;
            default:
                break;
        }
    }, [currentOnglet])

    const getPlayers = async () => {
        const link = domain + '/server/getPlayersClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPlayers(data);
            }
        })
    }

    const getPalmares = async () => {
        const link = domain + '/server/getPalmaresClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPalmares(data);
            }
        })
    }

    const getContact = async () => {
        const link = domain + '/server/getContactClub.php';
        await axios.post(
            link, 
            {
                championnat: championnat,
                club: club.id,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setContacts(data);
            }
        })
    }

    const ONGLETS = [
        {id: 1, label: 'Joueurs'},
        {id: 2, label: 'Calendrier / Résultats'},
        // {id: 3, label: 'Palmarès'},
        {id: 4, label: 'Contacts'},
    ];

    return (
        <div className={"details_club_page " + championnat}>

            {/* // BANNIERE */}
            <div className="details_club_hero">
                <div className="details_club_container details_club_hero_inner">
                    <div className="details_banniere_logo">
                        <LogoClub club={club} width='100%' height='100%' activateLink={false} />
                    </div>
                    <div className="details_club_hero_text">
                        <span className="details_club_hero_champ">{getLongNameChamp(championnat)}</span>
                        <h1 className="details_club_hero_title">{club.title}</h1>
                        {
                            club.ville &&
                            <span className="details_club_hero_ville">{club.ville}</span>
                        }
                    </div>
                </div>
            </div>

            <nav className="details_navbar">
                <div className="details_club_container details_navbar_inner" role="tablist">
                    {
                        ONGLETS.map((onglet) => (
                            <button
                                key={onglet.id}
                                type="button"
                                role="tab"
                                aria-selected={currentOnglet === onglet.id}
                                className={currentOnglet === onglet.id ? 'active' : ''}
                                onClick={()=>setCurrentOnglet(onglet.id)}
                            >
                                {onglet.label}
                            </button>
                        ))
                    }
                </div>
            </nav>

            <div className="details_club_content">


                {
                    (currentOnglet === 2 && <ClubCalendrier championnat={championnat} club={club}/>)
                    ||
                        (currentOnglet === 1 &&
                        <div className="details_club_container details_players_container">
                            {
                                players.sort((a, b) => a.classement - b.classement).map((item, index) => {
                                    return (
                                        // <ClubJoueur key={index} championnat={championnat} player={item} />
                                        <JoueurInfo key={index} championnat={championnat} player={item} />
                                    )
                                })
                            }
                        </div>)
                    ||
                    (currentOnglet === 4 &&
                    <div className="details_club_container details_club_info">
                        <section>
                            <h2 className="details_club_section_title">Contacts</h2>
                            {
                                (contacts.length > 0 &&
                                <div className="details_club_contacts">
                                    {
                                        contacts.map((item, index) => {
                                            return (
                                                <div key={index} className="details_club_person">
                                                    <img
                                                        src={process.env.PUBLIC_URL + (item.photoContact !== "" ? "/images/contacts/" + item.photoContact : "/images/no-photo.png")}
                                                        alt=""
                                                        width="72"
                                                        height="72"
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src=process.env.PUBLIC_URL + "/images/no-photo.png";
                                                        }}
                                                    />
                                                    <div className="details_club_person_text">
                                                        <span className="details_club_person_role">{item.roleContact}</span>
                                                        <span className="details_club_person_name">{item.prenomContact + " " + item.nomContact.toUpperCase()}</span>
                                                        {
                                                            item.emailContact &&
                                                            <a href={"mailto:" + item.emailContact}>{item.emailContact}</a>
                                                        }
                                                        {
                                                            item.telephoneContact &&
                                                            <a href={"tel:" + item.telephoneContact.replace(/\s/g, '')}>{item.telephoneContact}</a>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>)
                                ||
                                <p className="details_club_empty">Aucune information disponible</p>
                            }
                        </section>
                        <section>
                            <h2 className="details_club_section_title">Salle</h2>
                            {
                                (club.salle !== null &&
                                <div className="details_club_preview">
                                    {club.photoSalle && (
                                        <img
                                            src={process.env.PUBLIC_URL + "/images/salle/" + club.photoSalle}
                                            alt={club.salle || ""}
                                        />
                                    )}
                                    <div className="details_club_preview_text">
                                        <h3>{club.salle || ""}</h3>
                                        <span>{club.adresse || " "}</span>
                                        <span>{(club.cp || "") + " " + (club.ville || "")}</span>
                                        {
                                            club.url &&
                                            <a className="details_club_button" href={club.url} target="_blank" rel="noreferrer">Site officiel du club</a>
                                        }
                                    </div>
                                </div>)
                                ||
                                <p className="details_club_empty">Aucune information disponible</p>
                            }
                        </section>

                    </div>)
                    ||
                    (currentOnglet === 3 &&
                    <div className="details_club_palmares">
                        {
                            palmares.map((item, index) => {
                                return (
                                    <div key={index} className="palmares">
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/" + item.logo} 
                                            alt="" 
                                            width="100" 
                                            height="100"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                            }}
                                        />
                                        <div className="palmares_span_container" style={{display: 'flex', flexDirection: 'column'}}>
                                            <span style={{fontWeight: 'bold'}}>{item.title}</span>
                                            {
                                                <span style={{fontSize: 18}}>{item.subtitle}</span>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>)
                }

         
                    

            </div>
            
         
        </div>
    );
}

export default DetailsClub;